import axios from "axios";
import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneInput from "react-phone-number-input";
import { useNavigate } from "react-router-dom";
import IntlTelInput from "intl-tel-input/reactWithUtils";
import "intl-tel-input/styles";

const FormPage = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [country, setCountry] = useState("");
  const [enquiry, setEnquiry] = useState("");
  const [sales, setSales] = useState("");
  const [productPortfolio, setProductPortfolio] = useState("");
  const [capVal, setCapVal] = useState("");
  const navigate = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    if (!phoneNumber.trim()) {
      alert("Enter Contact Number");
      return;
    }
    const response = await fetch("/api/verify-captcha", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ capVal }),
    });

    const dataCaptcha = await response.json();
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const reqBody = {
      name,
      email,
      phoneNumber,
      companyName,
      enquiry,
      country,
      sales,
      productPortfolio,
    };
    if (dataCaptcha) {
      const { data } = await axios.post(
        "/api/form/request-a-quote",
        reqBody,
        config
      );
      if (data) {
        navigate("/details-submitted");
      }
    } else {
      alert("CAPTCHA Verification Failed!");
    }
  };
  return (
    <div>
      <div className="my-4 container">
        <h4 className="poppins-bold mb-2 text-uppercase text-center">
          Let’s Build Your Next Big Ride
        </h4>
        <div className="d-flex justify-content-center mb-3">
          <p className="text-center mb-0 col-md-8 text-muted">
            Connect with our business development team to explore how DYNEM can
            power your e-cycle vision
          </p>
        </div>
        <div className="row p-0">
          <div className="col-12 p-3">
            <h3 className="poppins-medium mb-2">Why Choose DYNEM?</h3>
            <div>
              <img
                src="https://ar-euro.s3.ap-south-1.amazonaws.com/dynem-24/landing+page+2/Group+49.jpg"
                className="img-fluid"
              ></img>
            </div>
          </div>
          <div className="col-12 p-3">
            <form className="" onSubmit={submit}>
              <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                <div className="w-100">
                  <label
                    for="exampleInputEmail1"
                    className="form-label"
                    style={{ fontSize: "0.8em" }}
                  >
                    Name*
                  </label>
                  <input
                    style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                    type="text"
                    value={name}
                    onChange={(e) => {
                      setName(e.target.value);
                    }}
                    required
                    class="form-control text-dark"
                    aria-describedby="emailHelp"
                  />
                </div>
              </div>
              <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                <div class="w-50">
                  <label
                    for="exampleInputPassword1"
                    class="form-label"
                    style={{ fontSize: "0.8em" }}
                  >
                    Contact No*
                  </label>
                  <IntlTelInput
                    onChangeNumber={setPhoneNumber}
                    initOptions={{
                      initialCountry: "auto",
                      geoIpLookup: function (success, failure) {
                        fetch("https://ipapi.co/json")
                          .then((res) => res.json())
                          .then((data) => success(data.country_code))
                          .catch(() => failure());
                      },
                      strictMode: true,
                      separateDialCode: true,
                    }}
                  />
                </div>
                <div className="w-50">
                  <label
                    for="exampleInputEmail1"
                    className="form-label"
                    style={{ fontSize: "0.8em" }}
                  >
                    Work Email*
                  </label>
                  <input
                    style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                    type="email"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                    }}
                    required
                    class="form-control rounded-0"
                    aria-describedby="emailHelp"
                  />
                </div>
              </div>

              <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                <div className="w-50">
                  <label
                    for="exampleInputEmail1 text-light"
                    style={{ fontSize: "0.8em" }}
                    className="form-label"
                  >
                    Company Name*
                  </label>
                  <input
                    type="text"
                    value={companyName}
                    style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                    required
                    onChange={(e) => {
                      setCompanyName(e.target.value);
                    }}
                    class="form-control"
                    aria-describedby="emailHelp"
                  />
                </div>
                <div className="w-50">
                  <label
                    for="exampleInputEmail1"
                    className="form-label"
                    style={{ fontSize: "0.8em" }}
                  >
                    Product Portfolio*
                  </label>
                  <select
                    onChange={(e) => setProductPortfolio(e.target.value)}
                    style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                    class="form-select"
                    required
                    defaultValue=""
                    aria-label="Default select example"
                  >
                    <option value="" selected disabled></option>
                    <option value="E-Bikes">E-Bikes</option>
                    <option value="E-Scooters">E-Scooters</option>
                    <option value="Hyper-Bikes">Hyper-Bikes</option>
                    <option value="Moped">Moped</option>
                  </select>
                </div>
              </div>

              <div class="mb-3 d-flex" style={{ gap: "1em" }}>
                <div className="w-50">
                  <label
                    for="exampleInputEmail1"
                    className="form-label"
                    style={{ fontSize: "0.8em" }}
                  >
                    Operational Countries*
                  </label>
                  <input
                    style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                    type="text"
                    value={country}
                    onChange={(e) => {
                      setCountry(e.target.value);
                    }}
                    class="form-control"
                    aria-describedby="emailHelp"
                  />
                </div>
                <div className="w-50">
                  <label
                    for="exampleInputEmail1"
                    className="form-label"
                    style={{ fontSize: "0.8em" }}
                  >
                    Annual E-Bike Sales (units)
                  </label>
                  <select
                    style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                    onChange={(e) => setSales(e.target.value)}
                    class="form-select"
                    required
                    defaultValue=""
                    aria-label="Default select example"
                  >
                    <option value="" selected disabled></option>
                    <option value="less than 1000 units">
                      less than 1000 units
                    </option>
                    <option value="1000-5000 units">1000-5000 units</option>
                    <option value="5000-50,000 units">5000-50,000 units</option>
                    <option value="50,000+ units">50,000+ units</option>
                  </select>
                </div>
              </div>
              <div className="mb-3">
                <label
                  for="exampleInputEmail1"
                  className="form-label"
                  style={{ fontSize: "0.8em" }}
                >
                  Post Your Enquiry*
                </label>
                <textarea
                  style={{ fontSize: "0.8em", backgroundColor: "#f5f5f5" }}
                  class="form-control rounded-0"
                  required
                  id="exampleFormControlTextarea1"
                  rows="3"
                  value={enquiry}
                  onChange={(e) => {
                    setEnquiry(e.target.value);
                  }}
                ></textarea>
              </div>
              <div className="mb-3 d-flex justify-content-center">
                <ReCAPTCHA
                  sitekey="6LftKugqAAAAAP-72NIok7YyszCs5TTba5QBtgBS"
                  onChange={(val) => setCapVal(val)}
                ></ReCAPTCHA>
              </div>
              <button
                disabled={!capVal}
                type="submit"
                style={{ backgroundColor: "#ff0000" }}
                class="btn btn-danger w-100 poppins-medium rounded-5 py-2"
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormPage;
